import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "London 2",
  "description": "",
  "published": "2007-09-19T00:00:00.000Z",
  "redirect_from": ["/blog/london-2/swizec/155"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Dan se je zacel odlicno s tezko pricakovanim internet fiksom. Sledil mu je dokaj nenavaden zajtrk v nekaksnem cudnem ritualu zajtrkovanja. Ocitno potovanje spremeni navade nejedenja zajtrka.`}</p>
    <p>{`pri naklucnjem pojanju naokoli in iskanju naprave z denarjem sem se nenadoma znasel ob napisu, ki je pravil "Camden town Hall" ampak na sreco je bila zraven tudi iskana naprava in izkazalo se je, kot po pricakovanjih, da slovenski plasticen denar deluje tudi v Londonu ... se sreca.`}</p>
    <p>{`Nekako sem se uspel spraviti v, kar bi se lahko poimenovalo, center Londona in si skusal ogledati tiste najpomembnejse pasti za turiste, Big Ben, Buckingham palace in tako naprej. Bile so nepricakovano problematicne za najditev, saj so razprsene po presentljivo velikem obmocju.`}</p>
    <p>{`Najboljsa je bila Westminster Abbey za katero se je treba posloviti od 7-ih funtov denarja, ampak se je povsem splacalo. Sicer sem mislil, da bo bolj cerkev pa se je izkazalo, da je bolj nekaksno pokopalisce. Vsebuje ogromno grobnic bogatih in pomembnih, kot na primer Rihard Levjesrcni in tako naprej. Odlicen je tudi t. i. Poet's Corner v katerem je pokopan tudi Chaucer in drugi pomembni ljudje literarne uspesnosti.`}</p>
    <p>{`Tower Bridge in London Tower sta bila malcek razocarajoca, ker sem tja prispel prepozno za vstop London Eye pa je bil s 15 funti cisti nateg, saj je lep razgled in vse, ampak 15 funtov je preprosto prevec.`}</p>
    <p>{`Pojanje po Londonu je zabavno ampak zvecer se lahko izkaze za rahlo bolece.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      